import React from 'react';
import { v4 as uuid } from 'uuid';

const CategoriesFilterSort = ({ type, heading, filter, typeFilter }) => {
  return (
    <div className="categoriesFilterSort">
      <h3 className="heading--small">{heading}</h3>
      <div className="categoriesFilterSort__select form__select">
        <select value={typeFilter} onChange={(e => { filter('sort', e.target.value) })} >
          {type.map(item => (
            <option key={uuid()} value={item.type}>
              {item.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  )

}
export default CategoriesFilterSort
